<template>
  <div style="display: flex">
    <div style="width: 20vw; padding: 1.5vw">
      <div style="display: flex; justify-content: space-around">
        <!-- <a-button
          @click="debouncedQueryFilterListAction"
          type="primary"
          icon="search"
        >
          查询
        </a-button> -->
        <a-button @click="resetFilter" type="link" style="font-size: 1.5vw">
          {{ $t("库里的叉车.重置筛选条件") }}
        </a-button>
      </div>

      <a-card class="FilterCard" size="small" style="width: 18vw">
        <template slot="title"
          ><a class="CardTitle">{{ $t("库里的叉车.模糊查询") }}</a>
        </template>
        <InputLikeSelect
          ref="InputLikeSelect"
          style="width: 13vw"
          stockpile="inputLikeSelect"
          @InputLikeSelect="InputLikeSelect"
          :columnsResult="columns"
        />
      </a-card>

      <a-card class="FilterCard" size="small" style="width: 18vw">
        <template slot="title"
          ><a class="CardTitle">{{ $t("库里的叉车.车辆品牌") }}</a>
        </template>
        <a-checkbox-group
          v-model="brandCheckedList"
          :options="brandList"
          class="list"
          :style="{
            height: (showBrand ? 4 : brandList.length) * 1.5 + 'vw',
          }"
          @change="debouncedQueryFilterListAction"
        />

        <div @click="showBrand = !showBrand">
          <a style="color: black; font-size: 0.75vw">{{
            showBrand ? $t("库里的叉车.+ 展开") : $t("库里的叉车.- 收起")
          }}</a>
        </div>
      </a-card>

      <a-card class="FilterCard" size="small" style="width: 18vw">
        <!-- <a slot="extra" href="#">more</a> -->
        <template slot="title"
          ><a class="CardTitle">{{ $t("库里的叉车.动力方式") }}</a>
        </template>
        <a-checkbox-group
          v-model="DongliCheckedList"
          :options="DongliList"
          @change="debouncedQueryFilterListAction"
        />
      </a-card>

      <a-card class="FilterCard" size="small" style="width: 18vw">
        <template slot="title"
          ><a class="CardTitle">{{ $t("库里的叉车.车辆类型") }}</a>
        </template>
        <a-checkbox-group
          v-model="cheliangTypeCheckedList"
          :options="cheliangTypeList"
          class="list"
          :style="{
            height:
              (showCheliangType ? 4 : cheliangTypeList.length) * 1.5 + 'vw',
          }"
          @change="debouncedQueryFilterListAction"
        />
        <div @click="showCheliangType = !showCheliangType">
          <a style="color: black; font-size: 0.75vw">{{
            showCheliangType ? $t("库里的叉车.+ 展开") : $t("库里的叉车.- 收起")
          }}</a>
        </div>
      </a-card>

      <!-- <a-card class="FilterCard" size="small" style="width: 200px">
        <template slot="title"
          ><a class="CardTitle">{{ $t("库里的叉车.属具类型") }}</a>
        </template>
        <a-checkbox-group
          v-model="aboutTypeCheckedList"
          :options="aboutTypeList"
          class="list"
          :style="{
            height: (showAboutType ? 4 : aboutTypeList.length) * 27 + 'px',
          }"
          @change="aboutChange"
        />
        <div @click="showAboutType = !showAboutType">
          <a style="color: black">
            {{
              showAboutType ? $t("库里的叉车.+ 展开") : $t("库里的叉车.- 收起")
            }}
          </a>
        </div>
      </a-card> -->

      <a-card class="FilterCard" size="small" style="width: 18vw">
        <template slot="title"
          ><a class="CardTitle">{{ $t("库里的叉车.门架类型") }}</a>
        </template>
        <a-checkbox-group
          v-model="menjiaTypeCheckedList"
          :options="menjiaTypeList"
          @change="debouncedQueryFilterListAction"
        />
      </a-card>

      <!-- <a-card class="FilterCard" size="small" style="width: 200px">
        <template slot="title"
          ><a class="CardTitle">{{ $t("库里的叉车.阀路") }}</a>
        </template>
        <a-checkbox-group
          v-model="faluCheckedList"
          :options="faluList"
          @change="faluChange"
        />
      </a-card> -->

      <a-card class="FilterCard" size="small" style="width: 18vw">
        <template slot="title"
          ><a class="CardTitle">{{ $t("库里的叉车.载重能力") }}</a>
        </template>
        <div>
          <a-slider
            range
            :step="100"
            :default-value="[500, 20000]"
            v-model="KGValue"
            :min="500"
            :max="20000"
            @afterChange="debouncedQueryFilterListAction"
          />
        </div>
        <div style="display: flex">
          <div style="flex: 5">
            <a-input-number
              v-model="KGValue[0]"
              :step="10"
              :min="500"
              @change="debouncedQueryFilterListAction"
            />
            <span>kg</span>
          </div>
          <div style="flex: 5">
            <a-input-number
              v-model="KGValue[1]"
              :step="10"
              :max="20000"
              @change="debouncedQueryFilterListAction"
            />
            <span>kg</span>
          </div>
        </div>
      </a-card>

      <a-card class="FilterCard" size="small" style="width: 18vw">
        <template slot="title"
          ><a class="CardTitle">{{ $t("库里的叉车.提升高度") }}</a>
        </template>
        <div>
          <a-slider
            range
            :step="100"
            :default-value="[0, 20000]"
            v-model="TSValue"
            :min="0"
            :max="20000"
            @afterChange="debouncedQueryFilterListAction"
          />
        </div>
        <div style="display: flex">
          <div style="flex: 5">
            <a-input-number
              v-model="TSValue[0]"
              :step="100"
              :min="0"
              @change="debouncedQueryFilterListAction"
            />
            <span>mm</span>
          </div>
          <div style="flex: 5">
            <a-input-number
              v-model="TSValue[1]"
              :step="100"
              :max="20000"
              @change="debouncedQueryFilterListAction"
            />
            <span>mm</span>
          </div>
        </div>
      </a-card>

      <a-card class="FilterCard" size="small" style="width: 18vw">
        <template slot="title"
          ><a class="CardTitle">{{ $t("库里的叉车.叉车回落高度") }}</a>
        </template>
        <div>
          <a-slider
            range
            :step="100"
            :default-value="[0, 10000]"
            v-model="HLValue"
            :min="0"
            :max="10000"
            @afterChange="debouncedQueryFilterListAction"
          />
        </div>
        <div style="display: flex">
          <div style="flex: 5">
            <a-input-number
              v-model="HLValue[0]"
              :step="100"
              :min="0"
              @change="debouncedQueryFilterListAction"
            />
            <span>mm</span>
          </div>
          <div style="flex: 5">
            <a-input-number
              v-model="HLValue[1]"
              :step="100"
              :max="10000"
              @change="debouncedQueryFilterListAction"
            />
            <span>mm</span>
          </div>
        </div>
      </a-card>

      <a-card class="FilterCard" size="small" style="width: 18vw">
        <template slot="title"
          ><a class="CardTitle">{{ $t("库里的叉车.生产年份") }}</a>
        </template>
        <div>
          <a-slider
            range
            v-model="selectYear"
            :min="2000"
            :max="new Date().getFullYear()"
            @afterChange="debouncedQueryFilterListAction"
          />
        </div>
        <div style="display: flex">
          <div style="flex: 5">
            <a-input-number
              v-model="selectYear[0]"
              :min="0"
              @change="debouncedQueryFilterListAction"
            />
          </div>
          <div style="flex: 5">
            <a-input-number
              v-model="selectYear[1]"
              :max="new Date().getFullYear()"
              @change="debouncedQueryFilterListAction"
            />
          </div>
        </div>
      </a-card>

      <a-card class="FilterCard" size="small" style="width: 18vw">
        <template slot="title"
          ><a class="CardTitle">{{ $t("库里的叉车.工作小时数") }}</a>
        </template>
        <div>
          <a-slider
            range
            :step="100"
            :default-value="[0, 60000]"
            v-model="HValue"
            :min="0"
            :max="60000"
            @afterChange="debouncedQueryFilterListAction"
          />
        </div>
        <div style="display: flex">
          <div style="flex: 5">
            <a-input-number
              v-model="HValue[0]"
              :step="100"
              :min="0"
              @change="debouncedQueryFilterListAction"
            />
            <span>h</span>
          </div>
          <div style="flex: 5">
            <a-input-number
              v-model="HValue[1]"
              :step="100"
              :max="60000"
              @change="debouncedQueryFilterListAction"
            />
            <span>h</span>
          </div>
        </div>
      </a-card>

      <a-card class="FilterCard" size="small" style="width: 18vw">
        <template slot="title"
          ><a class="CardTitle">{{ $t("库里的叉车.其他") }}</a>
        </template>
        <a-checkbox-group
          v-model="otherCheckedList"
          :options="otherList"
          @change="debouncedQueryFilterListAction"
        />
      </a-card>
      <div
        style="display: flex; justify-content: space-around; margin-top: 1.5vw"
      >
        <!-- <a-button
          @click="debouncedQueryFilterListAction"
          type="primary"
          icon="search"
        >
          查询
        </a-button> -->
        <a-button @click="resetFilter" type="link" style="font-size: 1.5vw">
          {{ $t("库里的叉车.重置筛选条件") }}
        </a-button>
      </div>
    </div>
    <a-spin tip="Loading..." :spinning="loading" style="flex: 1">
      <div
        style="
          display: flex;
          flex-wrap: wrap;
          justify-content: space-evenly;
          padding: 1.5vw;
        "
      >
        <fork-model
          v-for="(item, index) in list"
          :key="index"
          :record="item"
          class="right mode-background"
        >
        </fork-model>
      </div>
    </a-spin>
  </div>
</template>

<script>
import moment from "moment";
import ForkModel from "../model/forkModel.vue";
import InputLikeSelect from "../model/InputLikeSelect.vue";
import axios from "axios";
import { getBucket } from "../utils/util";
import { columns } from "./forkliftList";

export default {
  components: { ForkModel, InputLikeSelect },

  data() {
    return {
      columns,
      KGValue: [500, 20000],
      TSValue: [0, 20000],
      HLValue: [0, 10000],
      HValue: [0, 60000],
      selectYear: [2000, new Date().getFullYear()],
      list: [],
      queryList: [],
      queryFilterList: [],
      InputLikeSelectValue: "",
      loading: false,
      brandList: [],
      brandCheckedList: [],
      showBrand: true,
      DongliList: [],
      DongliCheckedList: [],
      cheliangTypeList: [],
      cheliangTypeCheckedList: [],
      showCheliangType: true,
      aboutTypeList: [],
      aboutTypeCheckedList: [],
      showAboutType: true,
      menjiaTypeList: [],
      menjiaTypeCheckedList: [],
      faluList: [],
      faluCheckedList: [],
      otherList: [],
      otherCheckedList: [],
      mainOptions: {
        actionName: "getAssetReport",
        filters: {
          queryFilter: [
            {
              dataIndex: "type",
              operator: "eq",
              value: "车辆设备",
            },
            {
              dataIndex: "stateMsg",
              operator: "eq",
              value: "在库",
            },
          ],
        },
        orderBy: [
          {
            field: "reportTime",
            order: "desc",
          },
          {
            field: "code",
            order: "asc",
          },
          {
            field: "model",
            order: "asc",
          },
        ],
        offset: 0,
        limit: 2000,
      },
    };
  },
  created() {
    // 创建防抖函数，延迟500毫秒执行
    this.debouncedQueryAction = this.debounce(this.getQueryFilterList, 500);
    this.debouncedQueryFilterListAction = this.debounce(
      this.queryFilterListAction,
      500
    );
  },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: "instant", // 可选，设置为 'smooth' 可以平滑滚动
    });
    window.addEventListener("scroll", this.handleScroll);
    // window.addEventListener("resize", this.handleScroll);
    this.queryAction();
    this.queryBrand();
    this.queryDongli();
    this.queryCheliangType();
    // this.queryAboutType();
    this.queryMenjiaType();
    // this.queryfalu();
    this.queryOther();
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    fillterQuery() {
      //添加年份过滤
      this.mainOptions.filters.x_yearFillter = [
        {
          dataIndex: "factoryDate",
          operator: "lt",
          value: this.selectYear,
        },
      ];

      //添加品牌过滤条件
      if (this.brandCheckedList.length > 0) {
        this.mainOptions.filters.x_brandFillter = this.brandCheckedList.map(
          (item) => {
            return {
              dataIndex: "brand",
              operator: "eq",
              value: item,
            };
          }
        );
      }
      //添加动力方式过滤条件
      if (this.DongliCheckedList.length > 0) {
        this.mainOptions.filters.x_dongliFillter = this.DongliCheckedList.map(
          (item) => {
            return {
              dataIndex: "assetConfig",
              operator: "like",
              value: "动力方式:" + item,
            };
          }
        );
      }
      //添加车辆类型过滤条件
      if (this.cheliangTypeCheckedList.length > 0) {
        this.mainOptions.filters.x_cheliangFillter =
          this.cheliangTypeCheckedList.map((item) => {
            return {
              dataIndex: "assetConfig",
              operator: "like",
              value: "车辆类型:" + item,
            };
          });
      }
      //添加属具类型过滤条件
      if (this.aboutTypeCheckedList.length > 0) {
        this.mainOptions.filters.x_aboutFillter = this.aboutTypeCheckedList.map(
          (item) => {
            return {
              dataIndex: "assetConfig",
              operator: "like",
              value: "属具类型:" + item,
            };
          }
        );
      }
      //添加门架类型过滤条件
      if (this.menjiaTypeCheckedList.length > 0) {
        this.mainOptions.filters.x_menjiaFillter =
          this.menjiaTypeCheckedList.map((item) => {
            return {
              dataIndex: "assetConfig",
              operator: "like",
              value: "门架类型:" + item,
            };
          });
      }
      //添加阀路过滤条件
      if (this.faluCheckedList.length > 0) {
        this.mainOptions.filters.x_faluFillter = this.faluCheckedList.map(
          (item) => {
            return {
              dataIndex: "assetConfig",
              operator: "like",
              value: "阀路:" + item,
            };
          }
        );
      }
      //添加其他过滤条件
      if (this.otherCheckedList.length > 0) {
        this.mainOptions.filters.x_otherFillter = this.otherCheckedList.map(
          (item) => {
            return {
              dataIndex: "assetConfig",
              operator: "like",
              value: "其他:" + item,
            };
          }
        );
      }
      this.queryAction();
    },
    resetFilter() {
      this.selectYear = [2000, new Date().getFullYear()];
      this.KGValue = [500, 20000];
      this.TSValue = [0, 20000];
      this.HLValue = [0, 10000];
      this.HValue = [0, 60000];

      this.$refs.InputLikeSelect.clear();
      this.InputLikeSelectValue = "";
      //清空品牌多选框和过滤条件
      this.brandCheckedList = [];

      //清空动力方式多选框和过滤条件
      this.DongliCheckedList = [];
      //清空车辆类型多选框和过滤条件
      this.cheliangTypeCheckedList = [];
      //清空属具类型多选框和过滤条件
      // this.aboutTypeCheckedList = [];
      // delete this.mainOptions.filters.x_aboutFillter;
      //清空门架类型多选框和过滤条件
      this.menjiaTypeCheckedList = [];
      //清空阀路多选框和过滤条件
      // this.faluCheckedList = [];
      // delete this.mainOptions.filters.x_faluFillter;
      //清空其他多选框和过滤条件
      this.otherCheckedList = [];
      this.debouncedQueryFilterListAction();
      // this.queryFilterList = this.queryList;
      // this.getQueryFilterList(0, 15);
    },

    //条件过滤动作
    queryFilterListAction() {
      this.queryFilterList = this.queryList.filter((item) => {
        return (
          this.queryInputLikeSelect(item) &&
          this.brandChange(item) &&
          this.dongliChange(item) &&
          this.cheliangChange(item) &&
          this.aboutChange(item) &&
          this.menjiaChange(item) &&
          this.queryKGAfterChange(item) &&
          this.queryTSAfterChange(item) &&
          this.queryHLAfterChange(item) &&
          this.queryHAfterChange(item) &&
          this.onYearAfterChange(item) &&
          this.otherChange(item)
        );
      });
      this.getQueryFilterList(0, 20);
    },

    // 模糊查询，传入用户输入的数据
    InputLikeSelect(ev) {
      console.log("InputLikeSelect", ev);
      if (ev === "" || ev === "{}" || ev.length === 0) {
        this.InputLikeSelectValue = "";
      } else {
        this.InputLikeSelectValue = ev;
      }
      this.debouncedQueryFilterListAction();
    },
    queryInputLikeSelect(item) {
      if (!this.InputLikeSelectValue) return true;
      if (
        // item.brand.includes(this.InputLikeSelectValue) ||
        // item.factoryName.includes(this.InputLikeSelectValue) ||
        item.code
          .toUpperCase()
          .includes(this.InputLikeSelectValue.toUpperCase()) ||
        item.model
          .toUpperCase()
          .includes(this.InputLikeSelectValue.toUpperCase())
      ) {
        return true;
      }
      return false;
    },
    //品牌勾选
    brandChange(item) {
      if (this.brandCheckedList.length == 0) return true;
      for (let i = 0; i < this.brandCheckedList.length; i++) {
        if (item.brand == this.brandCheckedList[i]) {
          return true;
        }
      }
      return false;
    },

    //动力方式勾选
    dongliChange(item) {
      if (this.DongliCheckedList.length == 0) return true;
      for (let i = 0; i < this.DongliCheckedList.length; i++) {
        if (item.动力方式 == this.DongliCheckedList[i]) {
          return true;
        }
      }
      return false;
    },
    //车辆类型勾选
    cheliangChange(item) {
      if (this.cheliangTypeCheckedList.length == 0) return true;
      for (let i = 0; i < this.cheliangTypeCheckedList.length; i++) {
        if (item.车辆类型 == this.cheliangTypeCheckedList[i]) {
          return true;
        }
      }
      return false;
    },
    //属具类型勾选
    aboutChange(item) {
      if (this.aboutTypeCheckedList.length == 0) return true;
      for (let i = 0; i < this.aboutTypeCheckedList.length; i++) {
        if (item.属具类型 == this.aboutTypeCheckedList[i]) {
          return true;
        }
      }
      return false;
    },
    //门架类型勾选
    menjiaChange(item) {
      if (this.menjiaTypeCheckedList.length == 0) return true;
      for (let i = 0; i < this.menjiaTypeCheckedList.length; i++) {
        if (item.门架类型 == this.menjiaTypeCheckedList[i]) {
          return true;
        }
      }
      return false;
    },
    //重量
    onKGAfterChange(obj) {
      this.minKG = obj[0];
      this.maxKG = obj[1];
      this.debouncedQueryFilterListAction();
    },

    //截取字符串后两位并返回数形
    removeLastTwoChars(str, sn) {
      // 检查字符串长度，确保至少有两位可以移除
      if (!str) {
        return 0;
      }
      if (str.length <= sn) {
        return 0; // 或者根据需要处理这种情况，比如返回原字符串或抛出错误
      }

      // 使用slice方法，从开始到倒数第三位
      let num = parseFloat(str.slice(0, -sn));
      return isNaN(num) ? 0 : num;
    },
    queryKGAfterChange(item) {
      if (JSON.stringify(this.KGValue) == JSON.stringify([500, 20000]))
        return true;
      if (
        this.parseStringToNumber(item.载重能力) >= this.KGValue[0] &&
        this.parseStringToNumber(item.载重能力) <= this.KGValue[1]
      ) {
        return true;
      }

      return false;
    },

    onTSAfterChange(obj) {
      this.TSValue = obj;
      this.debouncedQueryFilterListAction();
    },
    queryTSAfterChange(item) {
      if (JSON.stringify(this.TSValue) == JSON.stringify([0, 20000]))
        return true;
      if (
        this.parseStringToNumber(item.货叉最大升高) >= this.TSValue[0] &&
        this.parseStringToNumber(item.货叉最大升高) <= this.TSValue[1]
      ) {
        return true;
      }

      return false;
    },
    onHLAfterChange(obj) {
      this.minHL = obj[0];
      this.maxHL = obj[1];
      this.debouncedQueryFilterListAction();
    },
    queryHLAfterChange(item) {
      if (JSON.stringify(this.HLValue) == JSON.stringify([0, 10000]))
        return true;
      if (
        this.parseStringToNumber(item.叉车回落高度) >= this.HLValue[0] &&
        this.parseStringToNumber(item.叉车回落高度) <= this.HLValue[1]
      ) {
        return true;
      }

      return false;
    },
    //年份
    onYearAfterChange(item) {
      if (
        JSON.stringify(this.selectYear) ==
        JSON.stringify([2000, new Date().getFullYear()])
      )
        return true;

      if (
        item.factoryDate >= this.selectYear[0] &&
        item.factoryDate <= this.selectYear[1]
      ) {
        return true;
      }
      return false;
    },
    onHAfterChange(obj) {
      this.minH = obj[0];
      this.maxH = obj[1];
      this.debouncedQueryFilterListAction();
    },
    //截取字符串后两位并返回数形
    removeLast(str, sn) {
      // 检查字符串长度，确保至少有两位可以移除
      if (!str) {
        return 0;
      }
      if (str[str.length - 1] == "无") {
        return 0; // 或者根据需要处理这种情况，比如返回原字符串或抛出错误
      }
      let num = 0;
      if (str[str.length - 1] == "h") {
        num = parseFloat(str.slice(0, -1));
      } else {
        num = parseFloat(str);
      }

      // 使用slice方法，从开始到倒数第三位

      return isNaN(num) ? 0 : num;
    },
    parseStringToNumber(str) {
      // 使用正则表达式替换掉不需要的字符
      // console.log("str===", str);
      if (!str) {
        return 0;
      }
      if (str == "无") {
        return 0;
      }
      const cleanedStr = str.replace(/[kKgGmMhH ]|无/g, "");

      // 尝试将清理后的字符串转换为数字
      const number = parseFloat(cleanedStr);

      // 检查转换是否成功
      if (isNaN(number)) {
        console.error("字符串无法转换为数字");
        return 0;
      }

      return number;
    },
    queryHAfterChange(item) {
      if (JSON.stringify(this.HValue) == JSON.stringify([0, 60000]))
        return true;
      if (
        this.parseStringToNumber(item.购入时工时) >= this.HValue[0] &&
        this.parseStringToNumber(item.购入时工时) <= this.HValue[1]
      ) {
        return true;
      }

      return false;
    },
    //其他勾选
    otherChange(item) {
      if (this.otherCheckedList.length == 0) return true;
      for (let i = 0; i < this.otherCheckedList.length; i++) {
        if (item.其他 == this.otherCheckedList[i]) {
          return true;
        }
      }
      return false;
    },

    //查询其它过滤条件
    queryOther() {
      axios({
        url: this.$apiUrl + "/api/general/querySingle",
        method: "POST",
        data: {
          tableName: "platform_option",
          id: "16",
        },
      }).then((res) => {
        this.otherList = res.data.data.optionArr.split(",");
      });
    },
    //查询阀路
    queryfalu() {
      axios({
        url: this.$apiUrl + "/api/general/querySingle",
        method: "POST",
        data: {
          tableName: "platform_option",
          id: "9",
        },
      }).then((res) => {
        this.faluList = res.data.data.optionArr.split(",");
      });
    },
    //查询门架类型
    queryMenjiaType() {
      axios({
        url: this.$apiUrl + "/api/general/querySingle",
        method: "POST",
        data: {
          tableName: "platform_option",
          id: "8",
        },
      }).then((res) => {
        this.menjiaTypeList = res.data.data.optionArr.split(",");
      });
    },
    //查询属具类型
    queryAboutType() {
      axios({
        url: this.$apiUrl + "/api/general/querySingle",
        method: "POST",
        data: {
          tableName: "platform_option",
          id: "7",
        },
      }).then((res) => {
        this.aboutTypeList = res.data.data.optionArr.split(",");
      });
    },
    //查询车辆类型
    queryCheliangType() {
      axios({
        url: this.$apiUrl + "/api/general/querySingle",
        method: "POST",
        data: {
          tableName: "platform_option",
          id: "6",
        },
      }).then((res) => {
        this.cheliangTypeList = res.data.data.optionArr.split(",");
      });
    },
    //查询动力方式
    queryDongli() {
      axios({
        url: this.$apiUrl + "/api/general/querySingle",
        method: "POST",
        data: {
          tableName: "platform_option",
          id: "15",
        },
      }).then((res) => {
        this.DongliList = res.data.data.optionArr.split(",");
      });
    },
    //查询车辆品牌
    queryBrand() {
      axios({
        url: this.$apiUrl + "/api/general/querySingle",
        method: "POST",
        data: {
          tableName: "platform_option",
          id: "1",
        },
      }).then((res) => {
        this.brandList = res.data.data.optionArr.split(",");
      });
    },
    debounce(func, wait, immediate) {
      let timeout;
      return function () {
        let context = this,
          args = arguments;
        let later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    handleScroll() {
      // 处理滚动事件
      // console.log(window.scrollY); // 输出当前滚动位置
      // const scrollTop =
      //   document.documentElement.scrollTop || document.body.scrollTop;
      // const scrollHeight =
      //   document.documentElement.scrollHeight || document.body.scrollHeight;
      // const clientHeight =
      //   document.documentElement.clientHeight || window.innerHeight;
      // if (scrollTop + clientHeight >= scrollHeight) {
      //   this.mainOptions.offset = this.list.length;
      //   this.debouncedQueryAction(0, this.list.length + 12);
      // }
      const scrollTop = window.scrollY;
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = window.innerHeight;
      // console.log("scrollHeight==", scrollHeight);
      // console.log("clientHeight==", clientHeight);
      // console.log("scrollTop==", scrollTop);
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        this.mainOptions.offset = this.list.length;
        this.debouncedQueryAction(0, this.list.length + 20);
      }
    },
    async getImg(addr, id) {
      let a = await getBucket(addr, id)[0];
      return a ? a : "../img/wtupian.png";
    },
    queryAction() {
      this.loading = true;
      axios
        .post(this.$apiUrl + "/api/general/queryAction", this.mainOptions)
        .then((res) => {
          console.log(res);
          this.loading = false;
          let temp = res.data.data.map((item) => {
            item.assetConfig.split(";").forEach((obj) => {
              const e = obj.split(":");
              item[e[0]] = e[1];
            });
            item.tags = JSON.parse(item.tags);
            return {
              ...item,
            };
          });
          this.queryList = temp;
          this.queryFilterList = temp;
          this.debouncedQueryFilterListAction();
          // this.getQueryFilterList(0, 15);
          // console.log("res.data.data===", temp);
        });
    },
    getQueryFilterList(start, end) {
      this.loading = true;
      // console.log(this.loading);
      setTimeout(() => {
        this.list = this.queryFilterList.slice(start, end);
        console.log(this.list);
        this.loading = false;
      }, 300);

      // console.log(this.loading);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.ant-checkbox-group-item {
  display: block !important;
  padding-top: 0.15vw;
  padding-bottom: 0.15vw;
  margin-right: 0.2vw;
}

.list {
  overflow: hidden;
  transition: height 0.5s ease-out; /* 添加过渡效果 */
}

.mode-background {
  position: relative;
  width: 17.5vw;
}
.mode-background::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1; /* 将伪元素置于内容下方 */
  padding: 2.5vw; /* 与内边距相同，确保阴影从内容区域开始 */

  box-shadow: 0.5vw 0.5vw 1vw rgba(0, 0, 0, 0.19); /* 添加阴影 */
}
.right {
  /* 添加过渡效果，这样阴影和放大都能有动画 */
  transition: transform 0.1s ease, box-shadow 0.1s ease;
}

.right:hover {
  /* 悬停时放大 */
  transform: scale(1.05);
  /* 悬停时改变阴影效果，使其更明显 */
  /* box-shadow: 8px 8px 8px rgba(0, 0, 0, 0.3); */
}
.code-box-demo .ant-slider {
  margin-bottom: 0.8vw;
}
.FilterCard {
  background-color: #f3f3f3;
  padding: 0.6vw;
  border-radius: 0.6vw;
  margin-top: 1vw;
}
.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0px;
}
/deep/.ant-checkbox-wrapper {
  font-size: 0.75vw;
}
/deep/.ant-checkbox + span {
  font-size: 0.75vw;
}
// /deep/input {
//   font-size: 1vw;
// }
.CardTitle {
  color: #0067b3;
  font-size: 1vw;
  padding-bottom: 0.6vw;
}
.a-ckbox {
  margin-left: 0px;
  padding-left: 0px;
  padding-bottom: 0.3vw;
}

/deep/ .ant-checkbox-inner {
  width: 1vw;
  height: 1vw;
}
//下面部分不能省，会导致，虽然改变了框大小但是无法勾中复选框
.ant-checkbox-checked .ant-checkbox-inner {
  background-color: black;
  border-color: black;
}
</style>
